import { initSensors, } from '@nio-fe/challenger-data-track';
import { ALPS_TRACKER_PROD_URL, ALPS_TRACKER_TEST_URL, ENV_TYPE, FY_TRACKER_PROD_URL, FY_TRACKER_TEST_URL, } from '@/enums/configs';
import { getEnv, isAlps, isFy, } from '@/utils/env';

export const setupTracker = () => {
  try {
    const env = getEnv();

    let testServerUrl = '',prodServerUrl='';
      if(isAlps){
        testServerUrl = ALPS_TRACKER_TEST_URL
        prodServerUrl = ALPS_TRACKER_PROD_URL
      }else if(isFy){
        testServerUrl = FY_TRACKER_TEST_URL
        prodServerUrl = FY_TRACKER_PROD_URL
      }else{
        // nio
        testServerUrl = '';
        prodServerUrl = ''
      }


    initSensors({
      isProd: !import.meta.env.DEV && (!env || env === ENV_TYPE.PROD),
      testServerUrl: testServerUrl,
      prodServerUrl: prodServerUrl,
      use_auto_track_click: false, // 开启自动上报点击事件埋点
      use_auto_track_expo: false, // 开启自动上报元素曝光事件埋点
      auto_track_exposure_options: {
        // 元素曝光事件埋点相关配置项
        area_rate: 1, // 曝光比例。默认：1，值域：0~1。类型：Number
        stay_duration: 2, // 有效曝光停留时长。 默认：0。类型：Number
        repeated: true, // 重复曝光。 默认：true。类型：Boolean
      },
      use_auto_track_duration: false, // 开启自动上报页面浏览时长事件埋点
    });

  } catch (error) {
    console.error('[setup tracker error]', error);
  }
};

export default setupTracker;
